const MuiAccordion = {
  defaultProps: {
    square: true,
  },
  styleOverrides: {
    root: {
      '&.Mui-expanded': { margin: 0 },
      '&:before': { display: 'none' },
    },
  },
};

export default MuiAccordion;
